/**
 * Normaliaze issues
 * @param {*} issues
 */
const normalizeIssues = ({ globalIssues, cellIssues, rowIssues }) => ({ global: globalIssues, cell: cellIssues, row: rowIssues })

export default {
    normalizeIssues,
}
